module.exports = {"introText":"xxx","firstBoxHeader":"Modern","firstBoxText":"xxx","secondBoxHeader":"Secure","secondBoxText":"xxx","thirdBoxHeader":"Scalable","thirdBoxText":"xxx","localizationHeader":"Localization","localizationFirst":"xxx","localizationSecond":"xxx","errorhandlingHeader":"Error handling","errorhandlingFirst":"xxx","compatibilityHeader":"Compatibility","compatibilityFirst":"xxx"}


//////////////////
// WEBPACK FOOTER
// ./src/app/core/lang/en.lang.json
// module id = 338
// module chunks = 1